import React from "react";
import { Controller } from "react-hook-form";

const SelectInput = ({ control, name, label, options, required }) => {
  return (
    <div className="input-text">
      {label && <label className="input-label">{label}</label>}
      <Controller
        name={name}
        control={control}
        rules={{ required }}
        render={({ field }) => (
          <select id={name} {...field} className="select-input">
            {options?.map((option) => (
              <option key={option.value} value={option.value}>
                {option.description}
              </option>
            ))}
          </select>
        )}
      />
    </div>
  );
};

export default SelectInput;
